import {
  Backdrop,
  Drawer,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { getNotifications } from 'controllers/notifications/getNotifications';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { EmptyNotification } from './emptyNotification';
import { NotificationList } from './notificationList';

const useStyles = makeStyles({
  drawerContainer: {
    width: '400px',
  },
  backdrop: {
    zIndex: 1101,
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
  },
  notificationHeader: {
    padding: '16px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerText: {
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0.49px',
    color: 'rgba(0,0,0,0.87)',
  },
  headerCloseIcon: {
    color: 'rgba(0,0,0,0.87)',
    height: '20px',
    width: '20px',
    cursor: 'pointer',
  },
});

export const Notification = ({ isOpen = true, toggleView }) => {
  const classes = useStyles();
  const notifications = useSelector((state) => state.user.notifications);
  const hasNotifications = Boolean(
    notifications.list && notifications.list.length
  );

  useEffect(() => {
    getNotifications();
  }, []);

  const loadMore = () => {
    getNotifications(true);
  };

  return (
    <>
      <Backdrop
        open={isOpen}
        onClick={toggleView}
        classes={{ root: classes.backdrop }}
      />
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={toggleView}
        variant="persistent"
        classes={{ paper: classes.drawerContainer }}
      >
        <Grid container>
          <Grid item xs={12} classes={{ root: classes.notificationHeader }}>
            <Typography classes={{ root: classes.headerText }}>
              Notification
            </Typography>
            <Close
              classes={{ root: classes.headerCloseIcon }}
              onClick={toggleView}
            />
          </Grid>
          {hasNotifications ? (
            <NotificationList
              notifications={notifications.list}
              loadMore={loadMore}
              hasMore={notifications.hasMore}
            />
          ) : (
            <EmptyNotification />
          )}
        </Grid>
      </Drawer>
    </>
  );
};
